import React from 'react'
import BooksDetail from '../books/BooksDetail'
import { ELibraryCategory } from '../../enum/elibrary_enum'
import { routeName } from '../../../../routes/routeName'

type Props = {}

const TheSisDetail: React.FC<Props> = ({ }: Props) => {
    return (
        <BooksDetail
            library_category={ELibraryCategory.THESIS}
            library_head_name='วิทยานิพนธ์'
            library_head_pathname={routeName.e_library.the_sis}
            library_head_list_path={routeName.e_library.the_sis_list}
        />
    )
}

export default TheSisDetail